import React from "react";
import { AudioLines, ScanEye, Car, KeyRound, UserCheck, Siren } from "lucide-react";

const FEATURES = [
  { icon: AudioLines, title: "Two-way talk-down", body: "Guards speak directly to anyone on the property to de-escalate or deter — live." },
  { icon: ScanEye, title: "AI-assisted detection", body: "Cameras surface threats in seconds and stream them straight to a real guard." },
  { icon: Car, title: "License-plate recognition", body: "Every vehicle at the gate is read, tagged, and matched to residents or flagged." },
  { icon: KeyRound, title: "Gate & access control", body: "Verify visitors and manage entry without burdening your on-site staff." },
  { icon: UserCheck, title: "A dedicated guard", body: "Assigned to your community — they learn your residents, vehicles and routines." },
  { icon: Siren, title: "Verified dispatch", body: "Real, eyes-on calls to police mean faster response and almost no false alarms." },
];

const Capabilities = () => (
  <section id="services" className="bg-[#F8FAFC] border-y border-[#0F172A]/[0.06] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6">
      <div data-reveal className="max-w-2xl mb-14">
        <div className="inline-flex items-center gap-2 mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#D32F2F]">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D32F2F]" /> Command Center Operations
        </div>
        <h2 className="font-head text-4xl sm:text-5xl font-semibold tracking-tight text-[#0F172A] leading-[1.05]">
          Everything your community needs — in one service.
        </h2>
        <p className="text-[#0F172A]/55 mt-5 text-lg">
          We design, install, and actively monitor your system. One accountable partner, not a stack of vendors.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURES.map((f, i) => (
          <div key={f.title} data-reveal data-reveal-delay={(i % 3) + 1}
               className="rounded-2xl bg-white border border-[#0F172A]/[0.08] p-7 hover:border-[#D32F2F]/40 hover:shadow-[0_20px_50px_-26px_rgba(211,47,47,0.4)] transition-all duration-300">
            <span className="w-12 h-12 rounded-xl bg-[#D32F2F]/10 flex items-center justify-center mb-5">
              <f.icon className="w-6 h-6 text-[#D32F2F]" />
            </span>
            <h3 className="font-head text-lg font-semibold text-[#0F172A] mb-2">{f.title}</h3>
            <p className="text-[14px] text-[#0F172A]/60 leading-relaxed">{f.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Capabilities;
